import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1L26.5 26.5M26.5 1L1 26.5",
		stroke: "black",
		strokeWidth: 2
	})
});
export default SvgCloseIcon;
